<section id="privacy-hero" class="w-100 text-light" 
         style="margin-top: 66px; background: linear-gradient(45deg, #1A2042, #173580);">
  <div class="container py-5">
    <div class="">
      <!-- Left: About intro -->
      <div class="text-center mb-4 mb-lg-0">
        <h1 class="fw-bold mb-4">Looking for a job in the software industry?</h1>
        <p class="lead mb-4 fw-medium">
          At ChalkBasket, we prepare you with the right skills, tools, and guidance to secure a job in the software industry and grow into a successful tech career  
        </p>
        <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3" (click)="navigateAndScroll('/home')">
          Sign up for free
        </button>
      </div>
    </div>
  </div>
</section>

<section class="legal-section">
 <div class="legal-content container-md mt-5 mb-5">
   <h3 class="text-center">Privacy Policy</h3>
   <p class="text-center" style="color: gray;"><strong>Last Updated:</strong> November 6, 2025</p>
   <hr>

   <p>At <strong>ChalkBasket.com</strong>, your privacy is our priority. This Privacy Policy explains how we collect, use, and protect your personal information when you access our website, register for courses, or use our services.</p>

   <h4>1. Information We Collect</h4>
   <p>We may collect the following types of information:</p>
   <ul>
     <li><strong>Personal Information:</strong> Name, email address, phone number, academic details, and other details you provide during registration or inquiry.</li>
     <li><strong>Usage Information:</strong> Data on how you interact with our website (IP address, browser type, device information, pages visited, etc.).</li>
     <li><strong>Payment Information:</strong> When applicable, secure payment details for processing course fees (handled through trusted third-party providers).</li>
   </ul>

   <h4>2. How We Use Your Information</h4>
   <p>We use the information collected to:</p>
   <ul>
     <li>Provide and improve our courses and mentorship services.</li>
     <li>Communicate with you about updates, schedules, and learning resources.</li>
     <li>Personalize your learning experience.</li>
     <li>Process payments securely.</li>
     <li>Send important notifications, promotional content (with your consent), or service-related messages.</li>
   </ul>

   <h4>3. Sharing of Information</h4>
   <p>We respect your privacy and <strong>do not sell, rent, or trade your personal information</strong>. However, we may share your data with:</p>
   <ul>
     <li>Trusted service providers (e.g., payment processors, learning tools).</li>
     <li>Legal authorities if required by law or to protect our rights.</li>
   </ul>

   <h4>4. Data Security</h4>
   <p>We implement reasonable technical and organizational measures to protect your information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>

   <h4>5. Cookies</h4>
   <p>Our website may use cookies to enhance user experience, track usage patterns, and improve performance. You can choose to disable cookies through your browser settings.</p>

   <h4>6. Your Rights</h4>
   <p>You have the right to:</p>
   <ul>
     <li>Access, update, or delete your personal information.</li>
     <li>Opt-out of promotional communications.</li>
     <li>Request clarification on how your data is used.</li>
   </ul>

   <h4>7. Third-Party Links</h4>
   <p>Our website may contain links to third-party websites. We are not responsible for their privacy practices and encourage you to review their policies.</p>

   <h4>8. Updates to This Policy</h4>
   <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated date.</p>

   <h4>9. Contact Us</h4>
   <p>If you have any questions about this Privacy Policy or your personal information, please reach out to us via Contact Us page.</p>
 </div>
</section>
